<template>
  <i-dx-popup :popupVisible="popupVisible" :title="title" @popupCloseButtonClick="closeBtn" height="70vh" width="60vw">
    <template v-slot:grid>
      <div class="v-application " style="display: block !important; ">
        <v-row no-gutters class="px-6 py-5" style="height: calc(70vh - 178px)">
          <v-col :cols="mode !== 'single' ? 6 : 12" class="d-flex flex-column h-full">
            <div class="editor-label">공정 목록</div>
            <DxDataGrid
              :ref="dxDataGridRef"
              :data-source="processes"
              key-expr="id"
              height="calc(100% - 32px)"
              :selection="{ showCheckBoxesMode: 'none' }"
            >
              <DxColumn data-field="processNm" data-type="string" alignment="left" caption="공정명" :allow-editing="false" />
              <DxColumn data-field caption="선택" alignment="center" width="50px" :allow-editing="false" cell-template="selectButton" />
              <template #selectButton="{ data: cellInfo }">
                <v-btn
                  text
                  height="28"
                  class="move"
                  :color="checkColor(cellInfo) ? 'primary' : 'btn_text'"
                  @click="selectItem(cellInfo)"
                >
                  <svg-icon icon-class="grid-check" width="24" height="24"></svg-icon>
                </v-btn>
              </template>
            </DxDataGrid>
          </v-col>
          <v-col v-if="mode !== 'single'" cols="6" class="pl-5 d-flex flex-column h-full">
            <div class="editor-label">선택된 공정</div>
            <DxList
              ref="dxlist"
              id="simple-dxlist"
              class="popup-list"
              height="calc(100% - 32px)"
              :data-source="copySelected"
              :repaint-changes-only="true"
              key-expr="processId"
              show-scrollbar="always"
              :allow-item-deleting="true"
              :show-selection-controls="true"
              :search-enabled="true"
              :item-delete-mode="'static'"
              searchExpr="processNm"
              select-all-mode="allPages"
              item-template="list-item"
            >
              <template #list-item="{ data: item }">
                <div class="d-flex align-center">
                  <div class="list-title">
                    <v-checkbox v-model="item.useYn" true-value="Y" false-value="N"/>
                  </div>
                  <div class="list-title pl-2">{{ item.processNm }}</div>
                </div>
              </template>
            </DxList>
          </v-col>
        </v-row>
        <v-divider v-if="mode != 'single'" />
        <v-btn v-if="mode != 'single'" elevation="0" large color="primary" class="float-right rounded mr-6 mt-5" @click="btnApply">적용</v-btn>
      </div>
    </template>
  </i-dx-popup>
</template>

<script>
import IDxPopup from '@/components/common/iDxPopup.vue'
import { DxList } from 'devextreme-vue/list'
import { getCommonCode } from '@/api/common/commonApi'
import {
  getCompanyProcesses
} from '@/api/riskAssessment/riskAssessmentProcess.js'

import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    IDxPopup,
    DxList
  },
  props: {
    popupVisible: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String,
      default: () => ''
    },
    selected: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: () => 'single'
    }
  },
  data() {
    return {
      dxDataGridRef: 'datagrid',
      processes: [],
      copySelected: []
    }
  },
  computed: {},
  watch: {
  selected: {
    immediate: true, // 컴포넌트가 마운트 되는 즉시 실행
    handler(newVal, oldVal) {
      this.copySelected = JSON.parse(JSON.stringify(newVal))
    },
    deep: true //객체,배열 내부까지 감시
  },
  },
  mounted() {
    if (this.popupVisible) this.setCombobox()
  },
  methods: {
    checkColor(cellInfo) {
      let temp = this.copySelected
      let exists = temp.some(obj => JSON.stringify(obj.constructId + '_' +obj.processId) === JSON.stringify(cellInfo.data.constructId + '_' +cellInfo.data.processId))
      return exists
    },
    selectItem(cellInfo) {
      let temp = this.copySelected
      let exists = temp.some(obj => JSON.stringify(obj.constructId + '_' +obj.processId) === JSON.stringify(cellInfo.data.constructId + '_' +cellInfo.data.processId))
      if (exists) {
        this.vToastify(this.$t('이미 선택된 공정입니다.'), 'info')
        return
      } else {
        if (this.mode === 'single') {
          // SingleMode인 경우 선택한 row 정보를 바로 반환하고 종료
          let selected = this.copySelected
          selected.push(cellInfo.data)
          this.$emit('apply', selected)
        } else {
          this.copySelected.push(cellInfo.data)
        }
      }
    },
    btnApply() {
      this.vToastifyPrompt(
        this.$t('선택한 공정을 적용하시겠습니까?'),
        'info',
        current => {
          let selected = this.copySelected
          this.$emit('apply', selected)
        },
        null,
        true
      )
    },
    setCombobox() {
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId()
      }
      Promise.all([
        getCompanyProcesses(params, false)
      ]).then(response => {
        this.processes = response[0].list
      })
    },
    closeBtn() {
      this.$emit('popupClose')
    }
  }
}
</script>

<style lang="scss" scoped></style>
